import Vue from 'vue';
import Router from '@/router';
import VueI18n from '@/libs/i18n/index';
import whatsAppLogo from '@/assets/images/icons/whatsapp.png';
import { v4 as uuidv4 } from 'uuid'
// axios
import axios from 'axios';
import {
  baseURL, TOKEN_KEY, PROFILE_KEY, LANG, BRANCH_ID, CURRENT_YEAR,
} from './acl/config';
import { getSupportWhatsAppNumber } from './appHost';

const IDEMPOTENCY_KEY = 'current-idempotency-key';
const INACTIVE_BRANCH_ALLOWED_URLS = [
  'Users/auth',
  'aggregates/StartUp',
  'FiscalYears',
  'FavoriteRoutes',
  'SupportTicket',
  'Branches',
  'Tenants/design',
];

const axiosIns = axios.create({
  baseURL: baseURL,
});

axiosIns.interceptors.request.use((request) => {
  if (request.method === 'post' || request.method === 'put') {
    if (request.data) {
      if (Object.prototype.hasOwnProperty.call(request.data, 'englishName')) {
        request.data.englishName = request.data.englishName || request.data.arabicName;
      }

      let key = sessionStorage.getItem(IDEMPOTENCY_KEY);

      if (!key) {
        key = uuidv4();
        sessionStorage.setItem(IDEMPOTENCY_KEY, key);
      }

      request.headers['Idempotency-Key'] = key;
    }
  }
  const token = window.localStorage.getItem(TOKEN_KEY);
  const lang = window.localStorage.getItem(LANG);
  const branchId = window.localStorage.getItem(BRANCH_ID);
  const fiscalYear = window.localStorage.getItem(CURRENT_YEAR);
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  request.headers.Language = lang || 'en';
  if (branchId) request.headers.BranchId = branchId;
  if (JSON.parse(fiscalYear)) {
    request.headers.FiscalYear = JSON.parse(fiscalYear).year;
  } else {
    request.headers.FiscalYear = new Date().getFullYear();
  }
  if (request.method === 'get' && (request.url === 'Items/data-migration' || request.url === 'Items/data-migration-sales-prices' || request.url === 'Customers/data-migration' || request.url === 'Suppliers/data-migration' || request.url === 'Stocktakings/data-migration' || request.url === 'Vouchers/data-migration' || request.url === 'PriceLists/data-migration')) {
    request.responseType = 'arraybuffer';
    request.headers.Accept = 'application/octet-stream'
  }
  if (request.method === 'post' && (request.url === 'Items/data-migration' || request.url === 'Items/data-migration-sales-prices' || request.url === 'Customers/data-migration' || request.url === 'Suppliers/data-migration' || request.url === 'Stocktakings/data-migration' || request.url === 'Vouchers/data-migration' || request.url === 'PriceLists/data-migration')) {
    request.headers.ContentType = 'multipart/form-data'
  }

  const requestUrl = (request.url || '').split('?')[0];
  const isAllowedUrl = INACTIVE_BRANCH_ALLOWED_URLS.some((url) => requestUrl.startsWith(url));
  const currentBranch = require('@/store').default.getters['app/currentBranch'] || {};

  if (token && currentBranch.isActive === false && !isAllowedUrl) {
    Vue.swal({
      icon: 'error',
      title: VueI18n.t('error'),
      text: VueI18n.t('inactiveBranchError'),
      timer: 2000,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
    });
    return Promise.reject(new axios.Cancel(VueI18n.t('inactiveBranchError')));
  }

  return request;
});

axiosIns.interceptors.response.use(undefined, (error) => {
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }
  if (!error.response) {
    return Promise.reject(error);
  }
  if ([401].includes(error.response.status) && Router.history.current.fullPath !== '/login') {
    Vue.swal({
      icon: 'error',
      title: VueI18n.t('error'),
      text: VueI18n.t('expiredToken'),
      timer: 2000,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
    });
    Router.push('/login');
  } else {
    const originalRequest = error.config;
    // const token = window.localStorage.getItem(TOKEN_KEY)
    if (error.response.status === 401 && error.response.data.detail !== 'Tenant does not has active subscription' && error.response.data.detail !== 'Tenant subscription expired') {
      // const lang = window.localStorage.getItem(LANG);
      window.localStorage.setItem(TOKEN_KEY, '');
      window.localStorage.removeItem(PROFILE_KEY);
      Vue.swal({
        icon: 'error',
        title: VueI18n.t('error'),
        text: error.response.data.title === 'Unauthorized' && error.response.data.detail !== 'Tenant does not has active subscription' && error.response.data.detail !== 'Tenant subscription expired' ? 'خطأ في اسم المستخدم او كلمة المرور' : VueI18n.t(error.response.data.detail),
        timer: 2000,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      });
      if (Router.history.current.fullPath === '/login') {
        Router.push('/login');
      }
    } else if ([401, 500].includes(error.response.status) && (error.response.data.detail === 'Tenant does not has active subscription' || error.response.data.detail === 'Tenant Subscription Expired.')) {
      confirmActionTechSupport(
        {
          text: '',
          title: error.response.data.detail === 'Tenant Subscription Expired.' ? VueI18n.t('TenantSubscriptionExpired') : VueI18n.t(error.response.data.detail)
        },
        () => {
          // window.open(
          //   'http://wa.me/966596571141',
          //   '_blank' // <- This is what makes it open in a new window.
          // );
          window.open(
            `https://wa.me/${getSupportWhatsAppNumber()}`,
            '_blank'
          );
        }
      );
    } else if ([400, 409].includes(error.response.status)) {
      const data = error.response.data || {};
      const firstError = data.errors && (data.errors[0] ? data.errors[0].message : Object.values(data.errors)[0]);
      var errMsg = data.detail || (Array.isArray(firstError) ? firstError[0] : firstError);
      Vue.swal({
        icon: 'error',
        title: VueI18n.t('error'),
        text: VueI18n.t(errMsg),
        timer: 2000,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      });
    } else if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      window.localStorage.setItem(TOKEN_KEY, '');
      window.localStorage.removeItem(PROFILE_KEY);
      Vue.swal({
        icon: 'error',
        title: VueI18n.t('error'),
        text: VueI18n.t('expiredToken'),
        timer: 2000,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      });
      if (Router.history.current.fullPath !== '/login') {
        Router.push('/login');
      }
    } else if (error.response && error.response.status === 401) {
      window.localStorage.setItem(TOKEN_KEY, '');
      window.localStorage.removeItem(PROFILE_KEY);
      Router.push('/login');
    } else if (error.response && error.response.status === 401) {
      window.localStorage.setItem(TOKEN_KEY, '');
      window.localStorage.removeItem(PROFILE_KEY);
      Router.push('/login');
    }
    return Promise.reject(error);
  }
});
function confirmActionTechSupport(data, callbackFn) {
  const {
    title,
    text,
    type,
    confirmText,
    cancelText
  } = data;
  Vue.swal(
    {
      title: title,
      text: text,
      icon: type || 'warning',
      showCancelButton: false,
      confirmButtonText: confirmText || `<span class="align-middle">${VueI18n.t('contactWithUs')}</span>
    <img src="${whatsAppLogo}" width="20" class="ml-50" alt="" srcset="">`,
      cancelButtonText: cancelText || VueI18n.t('Cancel'),
      customClass: {
        confirmButton: 'btn btn-whatsApp text-white',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }
  )
    .then(
      (result) => {
        if (result.value) {
          if (callbackFn) callbackFn();
        }
      }
    );
}
Vue.prototype.$http = axiosIns;

export default axiosIns;
